export const defaultTheme = {
    '@btn-primary-bg': '@primary-color',
    '@layout-trigger-background-light': '@sider-background',
    '@mark-background': '#ffe58f',
}

export const contentstackTheme = {
    '@theme': 'contentStack',
    '@primary-color': '#2461b5',
    '@btn-primary-color': '#fff',
    '@btn-primary-bg': '@primary-color',
    '@mark-background': '#transparent',
    '@btn-default-bg': '#ddd',
    '@btn-default-color': '#000',
    '@codebox-color': '#f8f8f8',

    '@icon-background': '#ccc',
}

export const darkTheme = {
    '@scrte-theme': 'dark',
    '@primary-color': '#7289da',
    '@secondary-color': '#2c2f33',
    '@black': '#23272a',
    '@text-color': 'fade(@white, 85%)',
    '@heading-color': '@text-color',
    '@sider-text-color': '@text-color',
    '@link-color': '@primary-color',
    '@mark-background': '#4d4d00',
    '@body-background': '@black',
    '@sider-background': '@black',
    '@codebox-color': 'fade(@secondary-color, 95%)',
    '@popover-background': '#1f1f1f',
    '@layout-trigger-background-light': '@primary-color', //sider icon
    '@ant-upload-background': 'fade(@black, 85%)',
    '@btn-primary-bg': '@primary-color',
    '@btn-default-color': ' @text-color',
    '@btn-default-bg': "fade(@black, 70%)",
    "@btn-default-border": "fade(@black, 50%)",
    '@btn-text': '@black',




    // MODAL
    '@modal-background': '@secondary-color',
    '@modal-header-bg': '@modal-background',
    '@modal-content-bg': '@black',
    '@modal-footer-bg': '@modal-background',
    '@modal-heading-color': ' @heading-color',
    '@modal-close-color': '@text-color',

    //pagination
    '@pagination-item-bg': 'transparent',
    '@pagination-item-bg-active': 'transparent',
    '@pagination-item-link-bg': 'transparent',


    '@item-hover-bg': '@primary-color', //color for the toolbar dropdown option hover
    '@input-bg': 'transparent',
    '@input-color': '@text-color',
    '@input-placeholder-color': 'fade(@white, 50%)',
    '@label-color': '@text-color',

    '@select-background': 'transparent',
    '@select-item-active-bg': '@primary-color', //color for the select option hover
    '@select-dropdown-bg': '@popover-background',
    '@select-selection-text-color': '@black',

    '@dropdown-menu-bg': '@popover-background',
    '@tooltip-bg': '#434343',

    '@switch-bg': '@white',
    '@switch-color': '@primary-color',

    '@toolbar-background': '@secondary-color', //toolbar
    '@toolbar-icon-color': '#f2f2f2',

    '@card-head-color': '@text-color',
    '@card-background': '@modal-background',
    '@text-selection-bg': 'blue',

    '@skeleton-color': '#303030',

    '@table-bg': '@secondary-color',
    '@table-header-bg': '#1d1d1d',
    '@table-body-sort-bg': 'fade(@white, 1%)',
    '@table-row-hover-bg': '#262626',
    '@table-header-sort-bg': '#262626',
    '@table-header-filter-active-bg': '#434343',
    '@table-header-sort-active-bg': '#303030',
    '@table-filter-btns-bg': '@popover-background',
    '@table-expanded-row-bg': '@table-header-bg',
    '@table-filter-dropdown-bg': '@popover-background',
    '@table-expand-icon-bg': 'transparent',
    '@table-header-cell-bg': 'darken(@body-background,1%)',
    '@table-bg': '@body-background',
    '@code-bg-color': 'lighten(@body-background,20%)'
}
export const customTheme = {
    '@white': '#fff',
    '@black': '#000',
    '@custom-toolbar-icon': 'lighten(@black,30%)',
    '@primary-color': '#2461b5',
    '@secondary-color': '@white',
    '@modal-custom-bg': '@white',
    '@text-color': 'fade(@black, 85%)',
    '@heading-color': '@text-color',
    '@sider-text-color': '@text-color',
    '@link-color': '@primary-color',
    //modal
    '@modal-header-bg': '@modal-custom-bg',
    '@modal-content-bg': 'lighten(@modal-custom-bg,5%)',
    '@modal-footer-bg': '@modal-custom-bg',
    '@modal-heading-color': '@heading-color',
    '@modal-close-color': '@text-color',

    //button
    '@btn-primary-bg': '@primary-color',
    '@btn-default-color': ' @text-color',
    '@btn-default-bg': "#fff",
    //switch
    '@switch-color': '@primary-color',

    //toolbar
    '@toolbar-icon-color': '@custom-toolbar-icon',
    '@toolbar-background': '@white',

    '@body-background': '@white',
    '@sider-background': '@body-background',
    '@code-bg-color': 'lighten(@body-background,20%)'

}